<!--
 * @Description: 拖拽树结构
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <draggable animation="300" @scroll="handleScroll" @mouseleave="mouseLeave" chosen-class="chosen-class" v-model="myOptions" :group="{ name: 'itxst', pull: 'clone', put: false }" dragClass="ghost-dragg" @end="onEnd" @start="onStart" :move="onMove" :clone="clone" :class="{ 'tree-draggable': true, 'scrollbar-style-config': true, 'scroll-shadow-show': scrollShow }" filter=".unmover">
    <template #item="{ element }">
      <div class="draggable-item">
        <li @click.stop="openUl(element)" v-if="showTree(element)" :class="getElementClass(element, parentType, splitType)">
          <!-- 分组 -->
          <template v-if="element.level === 'parent'">
            <div class="fields-group">
              <template v-if="element?.fieldType !== 100 || splitType != 3">
                <icon-caret-down v-if="element?.isOpen && element?.level == 'parent'" class="fields-group-icon" />
                <icon-caret-right v-if="!element?.isOpen && element?.level == 'parent'" class="fields-group-icon" />
              </template>
              <div :class="['fields-group-label']">
                <template v-if="element?.fieldType !== 100 || splitType != 3">
                  <!-- <span class="fields-label">{{ element?.label }}</span> -->
                  <xl-label-text :value="element?.label" :row="1" />
                </template>
              </div>
            </div>
          </template>
          <template v-else>
            <!-- 字段 -->
            <div :class="['fields-info']">
              <template v-if="element?.level !== 'parent'">
                <span class="fields-icon"><component :is="element.comName" /></span>
              </template>
              <template v-if="element?.fieldType !== 100 || splitType != 3">
                <span class="fields-label" :title="element?.label">{{ element?.label }}</span>
              </template>
            </div>
          </template>

          <div v-if="fieldsMap.has(element?.value)" class="fields-count">
            {{ fieldsMap.get(element?.value) }}
          </div>

          <!-- 当有children，走递归。-->
          <ul v-if="element?.children && element?.children.length" v-show="element?.isOpen">
            <xl-tree :options="element?.children" :parentType="element?.fieldType" :type="props.type" :fieldsMap="props.fieldsMap"></xl-tree>
          </ul>
        </li>
      </div>
    </template>
  </draggable>
</template>
<script setup>
import { ref, inject, watchEffect } from 'vue';
import draggable from 'vuedraggable';
import { useLayoutStore } from '@/store';
import useFields from '@/hooks/fields';
import setScrollBar from '@/hooks/scrollbar-config';
// import { Message } from '@arco-design/web-vue';
const { scrollShow, handleScroll, mouseLeave } = setScrollBar();
const splitType = inject('sharedConfigData')?.splitType; // 布局分裂模式
import useObjectForm from '@/hooks/object-form';
const { getRecordType } = useObjectForm();

const { fieldIconMapping } = useFields();
const useLayout = useLayoutStore(); //视图及布局store
const props = defineProps({
  parentType: {
    type: String,
    default: null
  },
  options: {
    //树型结构数据
    type: Array,
    default: () => []
  },
  isRepeat: {
    //左侧是否可重复拖拽到右侧。默认不能重复：0 重复：1
    type: [Number, String],
    default: 0
  },
  type: {
    type: [Number, String]
  },
  fieldsMap: {
    // 左侧统计右侧字段出现数量
    type: Map,
    default: () => new Map()
  }
});
console.log('props.fieldsMap', props.fieldsMap);
// const emits = defineEmits(['cb']);

const dragType = ref(props.type);
console.log(61, dragType.value);
const drag = ref(false);
// const moveId = ref(-1); //拖拽的id
const elementData = ref(); //拖拽的数据
const openUl = (item) => {
  item.isOpen = !item.isOpen;
};

// 在组件的methods中定义
const getElementClass = (element, parentType, splitType) => {
  const classList = [];

  // 基础层级相关类名
  if (element?.level == 'children') {
    classList.push('tree-list');
  } else if (element?.level == 'parent') {
    classList.push('unmover-parent');
  } else {
    classList.push('unmover');
  }

  // 禁用状态类名
  if (element?.level == 'children' && element?.checked && parentType != 100) {
    classList.push('disabled');
  }

  // 分割类型相关类名
  if (splitType == 3) {
    classList.push('split-tree');
    // 组件分割特殊类名
    if (element?.fieldType == 100) {
      classList.push('split-component-tree');
    }
  }

  return classList.join(' ');
};
const showTree = (treeItem) => {
  console.log('treeItem', treeItem);
  if (treeItem.level === 'parent' && treeItem.children?.length == 0) {
    //父节点没有有子节点
    return false;
  }
  return true;
};

const myOptions = ref([]);
watchEffect(() => {
  myOptions.value = props.options;
  myOptions.value?.forEach((el) => {
    if (el.fieldType == 100 && splitType?.value) {
      el.isOpen = true;
    }
    if ([30, 31, 60].includes(Number(el.layoutFieldType))) {
      // 查找关联组件 外链容器
      el.comName = fieldIconMapping.value[Number(el.layoutFieldType)];
    } else {
      el.comName = fieldIconMapping.value[Number(el.fieldType)] || fieldIconMapping.value[Number(el.layoutFieldType)];
    }
  });
});
const detailDataRight = inject('sharedConfigData')?.detailData?.value; //右侧的默认数据

//左边往右边拖动时的事件
const onEnd = (e) => {
  drag.value = false;
  useLayout.setDrag(drag.value);
  useLayout.setDragElement(e, elementData.value); //保存被拖拽的元素
  useLayout.setDragLayoutType(0);
  console.log('detailDataRight', e);
  // const targetList = e.to?.__draggable_component__?.list;
  // const sourceModeValue = e.from?.__draggable_component__?.modeValue?.length;
  // const targetModeValue = e.to?.__draggable_component__?.modeValue?.length;
  // if (!e.pullMode && dragType.value == 1) {
  //   if (e.item?._underlying_vm_?.layoutFieldType == 20) {
  //     Message.warning('摘要区最多制定设置4个字段');
  //   } else {
  //     Message.warning('摘要区不能拖拽该字段类型');
  //   }
  // }
};
const onStart = (e) => {
  drag.value = true;
  useLayout.setDragLayoutType(parseInt(e?.item?.__draggable_context?.element?.layoutFieldType));
  useLayout.setDrag(drag.value);
  return true;
};
const onMove = (e) => {
  elementData.value = e.draggedContext.element; //被拖拽的字段
  //   console.log('draggedContext:--------', e);
  //   console.log('detailDataRight', detailDataRight);
  const targetClass = e.to.getAttribute('class');
  if (targetClass == 'tree-draggable') {
    return false;
  }
  if (elementData.value?.level == 'parent') {
    return false;
  }
  if (dragType.value == 3) {
    //导入导出需求逻辑

    // futureIndex:预测落点下标
    const futureIndex = e?.draggedContext?.futureIndex;
    if (typeof futureIndex === 'number' && futureIndex <= 0) {
      // 只禁止放到第 0 位（序号位置）
      return false;
    }

    // if (e?.relatedContext?.element?.fieldType == '-1') {
    //   //不可被拖拽入序号的位置
    //   return false;
    // }
    console.log('futureIndex', detailDataRight);
    const items = detailDataRight?.find((j) => j.fieldKey === elementData.value.fieldKey);
    if (items) {
      return false;
    }
  } else {
    if (props.isRepeat == 0 && detailDataRight?.length) {
      //数据不能重复
      const getLayoutType = Number(elementData.value.layoutFieldType);
      if ([20, 35, 30, 31].includes(getLayoutType)) {
        //字段
        const filterModules = (module) => {
          return module?.modules?.filter((n) => {
            const setKey = getRecordType(getLayoutType) && elementData.value.version == 1 ? elementData.value.value : elementData.value.fieldKey;
            return n.value == setKey;
          });
        };
        const items = detailDataRight?.map(filterModules).filter((el) => el?.length);
        if (items?.length) {
          if (getRecordType(getLayoutType) && !elementData.value?.version) {
            return true;
          }
          return false;
        }
      } else {
        //组件对象及对象字段
        const filterModules = (module) => {
          return module?.modules?.filter((n) => {
            return n.layoutFieldType == elementData.value.layoutFieldType;
          });
        };
        const items = detailDataRight.map(filterModules).filter((el) => el?.length);
        if (items?.length && elementData.value.layoutFieldType == '20') {
          return false;
        }
        //组件

        // const filterModules=[];
        // detailDataRight.forEach((item)=>{
        //     item?.modules?.forEach((n) => {
        //        if(n.layoutFieldType == e.draggedContext.element.layoutFieldType){
        //         filterModules.push(n);
        //       }
        //     })
        // })
        // console.log('filterModules', filterModules);
        // if (filterModules.length) return false;
      }
    }
  }

  e.draggedContext.element.checked = dragType.value == 1 ? false : true;
  useLayout.setDragElement(e, elementData.value); //保存被拖拽的元素
  return true;
};
//这一步最关键，没处理好，后面会数据混乱
//通过转成字符串，让他变成一个新对象，不然拖拽第二个组件将会和第一个组件一模一样，改变第一个组件第二个、第三个也会跟着变动。
const clone = (origin) => {
  const data = JSON.parse(JSON.stringify(origin));
  data.uniqueValue = parseInt(new Date().getMilliseconds() + '' + Math.ceil(Math.random() * 100000)).toString(16);
  useLayout.setDragElement('', data); //保存被拖拽的元素
  return data;
};
</script>

<style scoped lang="less">
@import './xl-tree.less';
</style>
